var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"hide-default-footer":"","headers":_vm.headers,"items":_vm.data,"text":""}})}
var staticRenderFns = []

export { render, staticRenderFns }